import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import * as url from '../../helpers/url_helper';
import { post } from '../../helpers/api_helper';

function AuthPage() {
  const history = useHistory();

  const saveAuth = async (obj) => {
    try {
      await post(url.POST_MICROSOFT_AUTHORIZATION, obj);

      history.push('/microsoft');
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    const params = window.location.search.substring(1).split('&');

    const obj = {};
    let buffer = '';
    for (let i = 0; i < params.length; i += 1) {
      const [key, value] = params[i].split('=', 2);

      if (key === 'code') {
        obj.authorization_code = value;
      } else if (key === 'client_info') {
        buffer = atob(value);

        try {
          const jobj = JSON.parse(buffer);
          obj.uid = jobj.uid;
        } catch (err) {
          // do nothing for now
        }
      } else if (key === 'state') {
        const match = value.match(/--([0-9]+)--$/);
        if (match !== null) {
          [, obj.id] = match;
        }
      }

      if (obj.id != null) {
        saveAuth(obj);
      }
    }
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <h1>Authorization Page</h1>
        <p>
          One moment...
          {' '}
          <span className="mdi mdi-spin mdi-loading" />
        </p>
      </div>
    </div>
  );
}

export default AuthPage;
